import React from 'react';
import moment from 'moment';
import Service from '../../config/networkutils';
import { getCookie } from '../../utils/CookieHelper';
import { CoffeeLoading, LoopCircleLoading, RotateCircleLoading } from 'react-loadingg';
import { withSnackbar } from 'notistack';
import ZoomIn from '@material-ui/icons/ZoomIn';
import ZoomOut from '@material-ui/icons/ZoomOut';
import CloseIcon from '@material-ui/icons/Close';
import { Autocomplete, ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import UserAllocation from '../UserAllocation/UserAllocation';
import { getEmployeesLeaves, getOtherTasks } from '../../config/PromisesHandler';
import StaffLocationViewHeader from './StaffLocationViewHeader';
import { getRoleGroups } from '../../config/PromisesHandler';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, TextField, Typography } from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import GetAppIcon from '@material-ui/icons/GetApp';
import { getPrimaryColor } from '../Helper/CommonThings';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const months = { 0: 'January', 1: 'Febrauary', 2: 'March', 3: 'April', 4: 'May', 5: 'June', 6: 'July', 7: 'August', 8: 'September', 9: 'October', 10: 'November', 11: 'December' }
const token = getCookie("ptd_ts_token");
const user = JSON.parse(getCookie("ptd_ts_user"));

class RoleGroupFilterControl extends React.PureComponent {
    constructor(props) {
        super(props)
        this.selectedRef = props.initialSelected || []
        this.state = {
            selected: this.selectedRef
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.resetKey !== this.props.resetKey) {
            this.selectedRef = this.props.initialSelected || []
            this.setState({ selected: this.selectedRef })
        }
    }

    render() {
        return (
            <>
                <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={this.props.options}
                    value={this.state.selected}
                    disableCloseOnSelect
                    onChange={(event, newValue) => {
                        this.selectedRef = newValue
                        this.setState({ selected: newValue })
                    }}
                    getOptionLabel={(option) => option.name}
                    getOptionSelected={(option, value) => option.id === value.id}
                    renderOption={(option, { selected }) => {
                        const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;
                        return (
                            <>
                                <SelectionIcon
                                    fontSize="small"
                                    style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                                />
                                {option.name}
                            </>
                        );
                    }}
                    style={{ width: '100%' }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Role Group"
                            placeholder="Role Group"
                            variant='outlined'
                        />
                    )}
                />
                <Button
                    variant="contained"
                    color="primary"
                    size='small'
                    style={{ marginLeft: '10px' }}
                    disabled={this.props.disabled}
                    onClick={() => this.props.onApply(this.selectedRef)}
                >
                    Filter
                </Button>
            </>
        )
    }
}
class ProjectStaffLocationView extends React.Component {
    constructor() {
        super()
        this.state = {
            allRoles: [],
            rolesObj: {},
            allEmp: [],
            isLoading: true,
            isLoading1: false,
            allProjects: [],
            responseData: [],
            projectObj: {},
            selectedRole: [],
            rolesData: [],
            searchRerenders: false,
            selectedSubSector: [],
            selectedOwnerRegion: [],
            selectedOwnerDelivery: [],
            showRole: false,
            showRoleIndex: null,
            selectedCrm: { name: '', id: '' },
            selectedEmployee: { first_name: 'Select Employee', last_name: '', id: '' },
            splittedRoleEmployees: [],
            selectedStartDate: moment().subtract(1, 'months').startOf('month'),
            selectedEndDate: moment().add(6, 'months').endOf('month'),
            allocationDialog: false,
            allocationDialogSize: 'xs',
            allocationData: null,
            toggleView: 'role',
            addEmpDisabled: false,
            type: 'week',
            zoom: 1,
            roleGroup: [],
            selectedRoleGroup: [],
            scrollTop: false,
            selectedRoleGrp: { id: '', name: "" },
            coffeeLoading: false,
            roles: [],
            roleGroups: [],
            selectedFilterRoleGroup: [],
            disciplineObj: {},
            reportTypeDialog: false,
            excelExportDialog: false
        }
        this.handleRefresh = this.handleRefresh.bind(this);
        this.getDialogSize = this.getDialogSize.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.addAllocation = this.addAllocation.bind(this);
        this.lastRoleGroupFilter = null;
    }

    getRoleGroupSelectionKey = (selectedGroups) => {
        if (!Array.isArray(selectedGroups) || selectedGroups.length === 0) {
            return ''
        }

        return selectedGroups
            .map((group) => group.id)
            .sort((a, b) => a - b)
            .join(',')
    }

    editedScheduleUIUpdate = (empArray) => {
        let allRoleEmployeess = [...this.state.responseData];
        for (let crmIndex = 0; crmIndex < allRoleEmployeess.length; crmIndex++) {
            for (let empIndex = 0; empIndex < empArray.length; empIndex++) {
                if ((allRoleEmployeess[crmIndex].crm === empArray[empIndex].crm) && (allRoleEmployeess[crmIndex].emp_id === empArray[empIndex].emp_id)) {
                    allRoleEmployeess[crmIndex] = empArray[empIndex];
                }
            }
        }
        this.setState({
            ...this.state,
            allRoleEmployees: allRoleEmployeess,
        });
    };

    getProjectsEmployees() {
        this.setState({ isLoading: true, isLoading1: true, addEmpDisabled: true, })

        let roles_crm_emp_id = ''
        if (this.state.type === 'week') {
            roles_crm_emp_id = `/api/crm/get_combined_demand/?crm=${this.props.crm.id}`
        } else if (this.state.type === 'month') {
            roles_crm_emp_id = `/api/crm/get_combined_demand/?change_report_type=month&crm=${this.props.crm.id}`
        } else if (this.state.type === 'quarter') {
            roles_crm_emp_id = `/api/crm/get_combined_demand/?change_report_type=quarter&crm=${this.props.crm.id}`
        }

        if (this.state.selectedCrm?.id) {
            let allocationData = { prj: { crm: this.state.selectedCrm.id, crm_name: this.state.selectedCrm.name } }
            this.setState({ allocationData })
            roles_crm_emp_id = roles_crm_emp_id + `crm=${this.state.selectedCrm.id}&`
        }
        if (this.state.selectedEmployee?.id) {
            roles_crm_emp_id = roles_crm_emp_id + `emp=${this.state.selectedEmployee.id}&`
        }

        if (this.state.selectedRoleGrp?.id) {
            roles_crm_emp_id = roles_crm_emp_id + `role_group=${this.state.selectedRoleGrp.id}&`
        }

        // if (this.state.selectedStartDate && this.state.selectedEndDate) {
        //     roles_crm_emp_id = roles_crm_emp_id + `from_date=${moment(this.state.selectedStartDate).format('YYYY-MM-DD')}&to_date=${moment(this.state.selectedEndDate).format('YYYY-MM-DD')}`
        // }

        Service.get(roles_crm_emp_id, {
            headers: { Authorization: "Token " + token, }
        })
            .then(res => {
                let rolesss;

                if (this.state.selectedRole.length === 0) {
                    rolesss = [...this.state.allRoles]
                } else {
                    rolesss = [...this.state.selectedRole]
                }
                this.setState({
                    reportedRoles: rolesss,
                    responseData: res.data.crm_data,
                    addEmpDisabled: this.state.selectedEmployee?.id ? true : false,
                }, () => this.makeReport(res.data?.crm_data?.roles, res.data?.all_dates, this.state.type, res.data?.crm_data))
            }).catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' })
                this.setState({ isLoading: false, isLoading1: false })
            })
    }

    getDropdownData() {
        return new Promise((resolve, reject) => {
            Service.get('/api/roles/get_default_data/', {
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => reject(error))
        })
    }

    getDiscipline() {
        Service.get('/api/subsector/get_with_delete_status/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let obj = {}
                for (let index = 0; index < res.data.length; index++) {
                    const element = res.data[index];
                    obj[element.id] = element.name
                }
                this.setState({ disciplineObj: obj })
            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                console.log(error)
            })

    }

    componentDidMount() {
        this.getDiscipline()
        Promise.all([
            this.getDropdownData(),
            getOtherTasks(),
            getEmployeesLeaves(),
            getRoleGroups(),
        ])
            .then(res => {
                let data = res[0].roles

                let rolesobj = {}
                data.forEach(ele => {
                    let newData = { [ele.id]: ele.job_roles }
                    rolesobj = { ...rolesobj, ...newData }
                })

                let projectObj = {}
                res[0].crm.forEach(ele => {
                    let newData = { [ele.id]: { project_code: ele.project_code, name: ele.name } }
                    projectObj = { ...projectObj, ...newData }
                })

                let othertaskObject = {}
                res[1].forEach(ele => {
                    let newData = { [ele.id]: ele.name }
                    othertaskObject = { ...othertaskObject, ...newData }
                })

                this.setState({
                    rolesObj: rolesobj,
                    allRoles: res[0].roles,
                    allEmp: res[0].employees,
                    allProjects: res[0].crm,
                    projectObj: projectObj,
                    isLoading: false,
                    allOtherTasks: res[1],
                    allEmployeesLeaves: res[2],
                    othertaskObject,
                    liveOpportunities: res[0].crm,
                    roleGroup: res[0].role_group,
                    roles: res[0].roles,
                    roleGroups: res[3],
                }, () => {

                    let searchParams = new URLSearchParams(window.location.search)
                    let selectedRoles = []
                    let selectedRegions = []
                    let selectedSubSectors = []
                    let selectedOwnerDeliverys = []
                    let selectedCrm = []
                    let selectedEmployee = []
                    let selectedRoleGroup = []
                    let selectedRoleGrp = []

                    if (searchParams.get("role")) {
                        let idNum = searchParams.get("role").split(',')
                        for (let id = 0; id < idNum.length; id++) {
                            let perRole = this.state.allRoles.filter((rol) => rol.id === parseInt(idNum[id]))
                            selectedRoles.push(perRole[0])
                        }
                    }

                    if (searchParams.get("roleGroup")) {
                        let idNum = searchParams.get("roleGroup").split(',')
                        for (let id = 0; id < idNum.length; id++) {
                            let perRoleGroup = this.state.roleGroup.filter(rg => rg.id === parseInt(idNum[id]))
                            selectedRoleGroup.push(perRoleGroup[0])
                        }
                    }

                    if (searchParams.get("roleGrp")) {
                        let idNum = searchParams.get("roleGrp")
                        selectedRoleGrp = this.state.roleGroup.filter(rg => rg.id === parseInt(idNum))[0]
                    }

                    if (searchParams.get("employee")) {
                        let idNum = searchParams.get("employee")
                        selectedEmployee = this.state.allEmp.filter(emp => emp.id === parseInt(idNum))[0]
                    } else {
                        selectedEmployee = { first_name: 'Select Employee', last_name: '', id: '' }
                    }

                    this.fetchOps()


                    if (selectedCrm.name || selectedEmployee.id || selectedRoleGrp.id) {
                        this.setState({
                            selectedRoleGrp, selectedRole: selectedRoles, selectedCrm, selectedEmployee, isLoading: true, toggleView: 'crm'
                        }, () => {
                            this.getProjectsEmployees()
                            if (this.props.changeViewParent) {
                                this.props.changeViewParent('crm')
                            }
                        })
                    } else if (selectedRoles.length > 0 ||
                        selectedRegions.length > 0 ||
                        selectedSubSectors.length > 0 ||
                        selectedOwnerDeliverys.length > 0 || selectedRoleGroup.length > 0) {
                        this.setState({
                            selectedRole: selectedRoles, selectedOwnerRegion: selectedRegions
                            , selectedSubSector: selectedSubSectors, selectedOwnerDelivery: selectedOwnerDeliverys, selectedRoleGroup, toggleView: 'role'
                        }, () => {
                            this.fetchOps()
                            if (this.props.changeViewParent) {
                                this.props.changeViewParent('role')
                            }
                        })
                    }
                })
            })
            .catch(e => {
                this.props.enqueueSnackbar('Something went wrong. Please try again later.', {
                    variant: 'error'
                });
            })

    }

    handleRefresh() {
        this.componentDidMount()
    }

    makeReport(allRoles, datesArray, type, data) {

        let reportedRoles = []
        let templateRoles = []
        let splittedRoleEmployees = []
        let finalColumns = []
        let allMonths = []

        const expandedRoles = []
        for (let i = 0; i < allRoles.length; i++) {
            const element = allRoles[i]
            const roleEntries = Array.isArray(element.prp_role) ? element.prp_role : []

            if (roleEntries.length === 0) {
                expandedRoles.push({ ...element, prp_role: [] })
                continue
            }

            for (let roleIndex = 0; roleIndex < roleEntries.length; roleIndex++) {
                const roleEntry = roleEntries[roleIndex]
                expandedRoles.push({
                    ...element,
                    employee_id: roleEntry.emp_id || '',
                    prp_role: [roleEntry]
                })
            }
        }

        allRoles = expandedRoles


        for (let index = 0; index < allRoles.length; index++) {
            const element = allRoles[index];

            const startOfMonth = this.state.selectedStartDate ? moment(this.state.selectedStartDate).startOf('month') : moment().subtract(2, 'months').startOf('month');
            const endOfMonth = this.state.selectedEndDate ? moment(this.state.selectedEndDate).endOf('month') : moment().add(6, 'months').endOf('month');

            let startDate = moment(startOfMonth)
            let endDate = moment(endOfMonth)

            let result = [];

            if (endDate.isBefore(startDate)) {
                throw new Error("End date must be greater than start date.")
            }

            while (startDate.isBefore(endDate)) {
                result.push(months[startDate.month()] + ' ' + startDate.year());
                startDate.add(1, 'month');
            }

            // let allWeekDates = weekStartDates(startOfMonth, endOfMonth);



            let final = []
            let colspan = 1;
            if (type === 'week') {
                for (let i = 0; i < datesArray.length; i++) {
                    let date = moment(datesArray[i], 'DD/MM/YYYY')
                    let monthYear = months[date.month()] + ' ' + date.year()
                    if (!result.length) {
                        result.push(monthYear)
                        final.push({ month: monthYear, colSpan: colspan })
                    }
                    else {
                        if (result[result.length - 1] === monthYear) {
                            colspan += 1
                            final[final.length - 1]['colSpan'] = colspan
                        }
                        else {
                            colspan = 1
                            result.push(monthYear)
                            final.push({ month: monthYear, colSpan: colspan })
                        }
                    }

                }
            } else if (type === 'month') {
                for (let i = 0; i < datesArray.length; i++) {
                    let date = moment(datesArray[i])
                    if (final.map((ele) => ele.month).indexOf(date.year()) === -1) {
                        final.push({ month: date.year(), colSpan: 1 })
                    } else {
                        final[final.map((ele) => ele.month).indexOf(date.year())]['colSpan'] += 1
                    }

                }
                console.log(final)
                console.log(datesArray)

            } else {
                for (let i = 0; i < datesArray.length; i++) {
                    let year = datesArray[i].split('-')[1]
                    if (final.map((ele) => ele.month).indexOf(year) === -1) {
                        final.push({ month: year, colSpan: 1 })
                    } else {
                        final[final.map((ele) => ele.month).indexOf(year)]['colSpan'] += 1
                    }

                }
            }
            for (let index = 0; index < final.length; index++) {
                const element = final[index];
                element.width = 150 * element.colSpan
            }

            allMonths = final



            reportedRoles.push(this.state.reportedRoles.filter((ele) => ele.id === element.role_id)[0])


            let weeks = [];
            let weekdata = [];
            let name = [];
            let subcontractor_company_name = [];
            for (let i = 0; i < element.prp_role.length; i++) {
                let roleItem = element.prp_role[i];
                const employeeName = [roleItem.emp_first_name, roleItem.emp_last_name].filter(Boolean).join(' ').trim();
                if (employeeName) {
                    name.push(employeeName)
                }
                if (roleItem.subcontractor_company_name) {
                    subcontractor_company_name.push(roleItem.subcontractor_company_name)
                }
                for (let m = 0; m < datesArray.length; m++) {
                    let date = datesArray[m]
                    if (roleItem.dates.hasOwnProperty(date) && roleItem.dates[date] !== 0) {
                        let project_code = data.crm_project_code + (employeeName ? ' (' + employeeName + ')' : '') + ' (Qty:' + roleItem.dates[date] + ')';
                        if (weeks.indexOf(date) === -1) {
                            weeks.push(date);
                            weekdata.push({ name: [data.crm_name], project_code: [[data.crm_project_code ? project_code : data.crm_name]], crmId: [data.crm_id], crm_color_code: [data.crm_color_code], leave: [roleItem.emp_leave ? roleItem.emp_leave[date] : ''], has_emp_name: [Boolean(employeeName)] })
                        } else {
                            if (weekdata[weeks.indexOf(date)]['name'] !== "") {
                                weekdata[weeks.indexOf(date)]['name'].push(data.crm_name)
                                weekdata[weeks.indexOf(date)]['project_code'].push(data.crm_project_code ? project_code : data.crm_name)
                                weekdata[weeks.indexOf(date)]['crmId'].push(data.crm_id)
                                weekdata[weeks.indexOf(date)]['crm_color_code'].push(data.crm_color_code)
                                weekdata[weeks.indexOf(date)]['leave'].push(roleItem.emp_leave ? roleItem.emp_leave[date] : '')
                                weekdata[weeks.indexOf(date)]['has_emp_name'].push(Boolean(employeeName))
                            } else if (weekdata[weeks.indexOf(date)]['name'] === "") {
                                weekdata[weeks.indexOf(date)]['name'].push(this.state.projectObj[data.crm_name])
                                weekdata[weeks.indexOf(date)]['project_code'].push(data.crm_project_code ? project_code : data.crm_name)
                                weekdata[weeks.indexOf(date)]['crmId'].push(data.crm_id)
                                weekdata[weeks.indexOf(date)]['crm_color_code'].push(data.crm_color_code)
                                weekdata[weeks.indexOf(date)]['leave'].push(roleItem.emp_leave ? roleItem.emp_leave[date] : '')
                                weekdata[weeks.indexOf(date)]['has_emp_name'].push(Boolean(employeeName))
                            }
                        }
                    }
                    else {
                        if (weeks.indexOf(date) === -1) {
                            weeks.push(date);
                            weekdata.push({ name: [], crmId: [], project_code: [], crm_color_code: [], leave: [], has_emp_name: [] })
                        }
                    }
                }
            }
            element['weeks'] = weeks;
            element['weekdata'] = weekdata;
            element['name'] = name.join(', ');
            element['subcontractor_company_name'] = subcontractor_company_name.join(', ');
            if (element.weekdata.length > 0) {
                if ((!element.end_date ? true : moment(element.end_date).isAfter(moment().format()))) {
                    // filterEmp.push(element)
                }
            }

            let columns = []
            for (let i = 0; i < datesArray.length; i++) {
                let newObj = {
                    title: type === "week" ? moment(datesArray[i], 'DD/MM/YYYY').format('DD MMM') : type === "month" ? moment(datesArray[i]).format('MMM YYYY') : type === "quarter" ? datesArray[i] : '',
                    field: datesArray[i],
                    type: 'number',
                    width: 150,
                    sorting: false,
                    editable: 'never',
                    filtering: false
                }
                columns.push(newObj)
            }
            finalColumns = columns
        }
        const filteredRoles = this.getEmployeesBySelectedRoleGroups(allRoles)
        splittedRoleEmployees.push({ role: 0, allEmpCopy: allRoles, allEmp: filteredRoles, columns: finalColumns, allMonths: allMonths })
        this.setState({ splittedRoleEmployees, reportedRoles, templateRoles, isLoading: false, isLoading1: false, }, () => {
        })
    }

    fetchOps() {
        this.setState({ isLoading1: true, addEmpDisabled: true })

        let selectedRolesIds = [];
        this.state.selectedRole.forEach((role) => {
            selectedRolesIds.push(role.id);
        });

        let selectedSubSectorsIds = [];
        this.state.selectedSubSector.forEach((sector) => {
            selectedSubSectorsIds.push(sector.id);
        });

        let selectedOwnerRegionIds = [];
        this.state.selectedOwnerRegion.forEach((region) => {
            selectedOwnerRegionIds.push(region.id);
        });

        let selectedOwnerDeliveryIds = [];
        this.state.selectedOwnerDelivery.forEach((odu) => {
            selectedOwnerDeliveryIds.push(odu.id);
        });

        let selectedRoleGroupIds = [];
        this.state.selectedRoleGroup.forEach((rg) => {
            selectedRoleGroupIds.push(rg.id);
        });

        let roles_sectors_regions_OD_uri = '';
        if (this.state.type === 'week') {
            roles_sectors_regions_OD_uri = '/api/prp/rolenew/get_staff_location_data/?archive_reason=0&'
        } else if (this.state.type === 'month') {
            roles_sectors_regions_OD_uri = '/api/prp/rolenew/get_staff_location_data/?archive_reason=0&change_report_type=month&'
        } else if (this.state.type === 'quarter') {
            roles_sectors_regions_OD_uri = '/api/prp/rolenew/get_staff_location_data/?archive_reason=0&change_report_type=quarter&'
        }
        if (selectedRolesIds.length > 0) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `role=${selectedRolesIds.join()}&`
        }
        if (selectedSubSectorsIds.length > 0) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `sector=${selectedSubSectorsIds.join()}&`
        }
        if (selectedOwnerRegionIds.length > 0) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `region=${selectedOwnerRegionIds.join()}&`
        }
        if (selectedOwnerDeliveryIds.length > 0) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `delivery=${selectedOwnerDeliveryIds.join()}&`
        }
        if (selectedRoleGroupIds.length > 0) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `role_group=${selectedRoleGroupIds.join()}&`
        }

        if (this.state.selectedEmployee?.id) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `emp=${this.state.selectedEmployee.id}`
        }
        if (roles_sectors_regions_OD_uri[roles_sectors_regions_OD_uri.length - 1] === "&") {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri.substring(0, roles_sectors_regions_OD_uri.length - 1)
        }

        if (this.state.selectedStartDate && this.state.selectedEndDate) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `&from_date=${moment(this.state.selectedStartDate).format('YYYY-MM-DD')}&to_date=${moment(this.state.selectedEndDate).format('YYYY-MM-DD')}`
        }

        roles_sectors_regions_OD_uri += '&is_active=True'

        Service.get(`/api/crm/get_combined_demand/?crm=${this.props.crm.id}`, {
            headers: {
                Authorization: "Token " + token,
            }
        })
            .then(res => {
                let rolesss;
                if (this.state.selectedRole.length === 0) {
                    rolesss = [...this.state.allRoles]
                } else {
                    rolesss = [...this.state.selectedRole]
                }
                this.setState({
                    reportedRoles: rolesss,
                    addEmpDisabled: false,
                    responseData: res.data.crm_data,
                }, () => this.makeReport(res.data.crm_data.roles, res.data.all_dates, this.state.type, res.data.crm_data))
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                this.setState({ isLoading: false, isLoading1: false })
            })
    }

    exportExcel(type) {
        this.setState({
            exporting: true
        })
        Service.get(`/api/crm/get_combined_demand/?crm=${this.props.crm.id}&get_report=true&change_report_type=${type}`, {
            headers: {
                Authorization: "Token " + token,
            }
        })
            .then(res => {
                this.props.enqueueSnackbar('Excel Report will be sent your email shortly!', { variant: 'success' })
                this.setState({
                    exporting: false
                })
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                this.setState({ isLoading: false, isLoading1: false, coffeeLoading: false, exporting: false })
            })
    }

    getExcelFileName = (type) => {
        return `staff-location-report-${type}-${moment().format('YYYYMMDD-HHmmss')}.xlsx`
    }

    filterCRM() {
        if (this.state.selectedRole.length > 0 || this.state.selectedOwnerRegion.length > 0 || this.state.selectedSubSector.length > 0 || this.state.selectedOwnerDelivery.length > 0 || this.state.selectedRoleGroup.length > 0) {
            this.fetchOps()
        } else {
            this.props.enqueueSnackbar('Please select atleast one of the filters!', { variant: 'warning' })
        }
    }

    reRenderingEmpLocation() {
        this.setState({ searchRerenders: true });
    }

    handleOwnerDeliveryChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value.length > 0) {
            let selectedOwnerDeliveryIds = [];
            value.forEach((od) => {
                selectedOwnerDeliveryIds.push(od.id)
            })
            if (searchParams.has("selectedOwnerDelivery")) {
                searchParams.set("selectedOwnerDelivery", selectedOwnerDeliveryIds.join(","))
            } else {
                searchParams.append("selectedOwnerDelivery", selectedOwnerDeliveryIds.join(","))
            }

        } else if (value.length === 0) {
            searchParams.delete("selectedOwnerDelivery")

        }
        // sessionStorage.setItem("lasturi", url + '?' + searchParams.toString())
        // window.history.pushState({ id: window.location.href }, '', url + '?' + searchParams.toString())
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);

        this.setState({ selectedOwnerDelivery: value })
    }

    handleSubSectorChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value.length > 0) {
            let selectedSubSectorIds = [];
            value.forEach((subSector) => {
                selectedSubSectorIds.push(subSector.id)
            })
            if (searchParams.has("selectedSubSector")) {
                searchParams.set("selectedSubSector", selectedSubSectorIds.join(","))
            } else {
                searchParams.append("selectedSubSector", selectedSubSectorIds.join(","))
            }

        } else if (value.length === 0) {
            searchParams.delete("selectedSubSector")
        }
        // sessionStorage.setItem("lasturi", url + '?' + searchParams.toString())
        // window.history.pushState({ id: window.location.href }, '', url + '?' + searchParams.toString())
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);


        this.setState({ selectedSubSector: value })
    }

    handleRoleChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value.length > 0) {
            let selectedRolesIds = [];
            value.forEach((region) => {
                selectedRolesIds.push(region.id)
            })
            if (searchParams.has("role")) {
                searchParams.set("role", selectedRolesIds.join(","))
            } else {
                searchParams.append("role", selectedRolesIds.join(","))
            }

        } else if (value.length === 0) {
            searchParams.delete("role")

        }
        // sessionStorage.setItem("lasturi", url + '?' + searchParams.toString())
        // window.history.pushState({ id: window.location.href }, '', url + '?' + searchParams.toString())
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);

        this.setState({ selectedRole: value, reportedRoles: value })
    }

    handleRoleGroupChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value.length > 0) {
            let selectedRoleGroupIds = [];
            value.forEach((region) => {
                selectedRoleGroupIds.push(region.id)
            })
            if (searchParams.has("roleGroup")) {
                searchParams.set("roleGroup", selectedRoleGroupIds.join(","))
            } else {
                searchParams.append("roleGroup", selectedRoleGroupIds.join(","))
            }
        } else if (value.length === 0) {
            searchParams.delete("roleGroup")
        }
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;
        window.history.pushState(null, '', newRelativePathQuery);
        this.setState({ selectedRoleGroup: value })
    }

    handleRoleGrpChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value) {
            if (searchParams.has("roleGrp")) {
                searchParams.set("roleGrp", value.id)
            } else {
                searchParams.append("roleGrp", value.id)
            }
        } else {
            searchParams.delete("roleGrp")
        }
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;
        window.history.pushState(null, '', newRelativePathQuery);
        this.setState({ selectedRoleGrp: value })
    }

    handleCrmChange(e, value) {
        let searchParams = new URLSearchParams(window.location.search)
        if (value) {
            if (searchParams.has("crm")) {
                searchParams.set("crm", value.id)
            } else {
                searchParams.append("crm", value.id)
            }
            let allocationData = { prj: { crm: value.id, crm_name: value.name } }
            this.setState({ allocationData })
        } else {
            this.setState({ allocationData: null })
            searchParams.delete("crm")
        }

        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);

        this.setState({ selectedCrm: value })
    }

    handleEmployeeChange(e, value) {
        let searchParams = new URLSearchParams(window.location.search)
        if (value) {
            if (searchParams.has("employee")) {
                searchParams.set("employee", value.id)
            } else {
                searchParams.append("employee", value.id)
            }
            this.setState({ addEmpDisabled: true })
        } else {
            this.setState({ addEmpDisabled: false })
            searchParams.delete("employee")
        }
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;
        window.history.pushState(null, '', newRelativePathQuery);
        this.setState({ selectedEmployee: value })
    }

    handleRegionChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value.length > 0) {
            let selectedRegionIds = [];
            value.forEach((region) => {
                selectedRegionIds.push(region.id)
            })
            if (searchParams.has("selectedOwnerRegion")) {
                searchParams.set("selectedOwnerRegion", selectedRegionIds.join(","))
            } else {
                searchParams.append("selectedOwnerRegion", selectedRegionIds.join(","))
            }
        } else if (value.length === 0) {
            searchParams.delete("selectedOwnerRegion")

        }

        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);

        this.setState({ selectedOwnerRegion: value })
    }

    openRole = (roleIndex) => { this.setState({ showRole: (!this.state.showRole), showRoleIndex: roleIndex }) }

    getReport() {
        this.setState({ isLoading1: true }, () => {
            this.setState({ isLoading1: false }, () => {
                if (this.state.selectedCrm?.id || this.state.selectedEmployee?.id || this.state.selectedRoleGrp?.id) {
                    this.setState({ isLoading: true, splittedRoleEmployees: [] }, () => {
                        this.getProjectsEmployees()
                    })
                } else if (this.state.selectedRole.length > 0 || this.state.selectedOwnerRegion.length > 0 || this.state.selectedSubSector.length > 0 || this.state.selectedOwnerDelivery.length > 0 || this.state.selectedRoleGroup.length > 0) {
                    this.filterCRM()
                } else {
                    this.fetchOps()
                }
            })
        })
    }

    prev6months = () => {
        if (!this.state.selectedStartDate || !this.state.selectedEndDate) {
            this.setState({ selectedStartDate: moment().subtract(2, 'months').startOf('month'), selectedEndDate: moment().add(6, 'months').endOf('month') }, () => {
                this.setState({ selectedStartDate: moment(this.state.selectedStartDate).subtract(6, 'months'), selectedEndDate: moment(this.state.selectedEndDate).subtract(6, 'months') }, () => {
                    this.getReports()
                })
            })
        } else {
            this.setState({ selectedStartDate: moment(this.state.selectedStartDate).subtract(6, 'months'), selectedEndDate: moment(this.state.selectedEndDate).subtract(6, 'months') }, () => {
                this.getReports()
            })
        }

    }

    next6months = () => {
        if (!this.state.selectedStartDate || !this.state.selectedEndDate) {
            this.setState({ selectedStartDate: moment().subtract(2, 'months').startOf('month'), selectedEndDate: moment().add(6, 'months').endOf('month') }, () => {
                this.setState({ selectedStartDate: moment(this.state.selectedStartDate).add(6, 'months'), selectedEndDate: moment(this.state.selectedEndDate).add(6, 'months') }, () => {
                    this.getReports(this.state.selectedStartDate, this.state.selectedEndDate)
                })
            })
        } else {
            this.setState({ selectedStartDate: moment(this.state.selectedStartDate).add(6, 'months'), selectedEndDate: moment(this.state.selectedEndDate).add(6, 'months') }, () => {
                this.getReports(this.state.selectedStartDate, this.state.selectedEndDate)
            })
        }
    }

    getReports() {
        if (!this.state.selectedEndDate || !this.state.selectedStartDate) {
            this.props.enqueueSnackbar("Please select the months!", {
                variant: "warning",
            });
        } else {
            this.getReport()
        }
    }

    getDialogSize = (size) => {
        this.setState({ allocationDialogSize: size })
    }

    closeDialog = () => {
        this.setState({ allocationDialog: false, allocationDialogSize: "xs", allocationData: null }, () => {
            if (this.state.selectedCrm?.id || this.state.selectedEmployee?.id || this.state.selectedRoleGrp?.id) {
                this.setState({ isLoading: true, splittedRoleEmployees: [] }, () => {
                    this.getProjectsEmployees()
                })
            } else if (this.state.selectedRole.length > 0 || this.state.selectedOwnerRegion.length > 0 || this.state.selectedSubSector.length > 0 || this.state.selectedOwnerDelivery.length > 0 || this.state.selectedRoleGroup.length > 0) {
                this.filterCRM()
            } else {
                this.fetchOps()
            }
        })
    }

    addAllocation = (emp, prj) => {
        let allocationData = { emp: emp, prj: prj }
        this.setState({ allocationData: allocationData }, () => {
            this.setState({ allocationDialog: true, allocationDialogSize: "xs" })
        })
    }

    roleGetReport() {
        let searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has("crm")) {
            searchParams.delete("crm")
        }
        if (searchParams.has("employee")) {
            searchParams.delete("employee")
        }
        if (searchParams.has("roleGrp")) {
            searchParams.delete("roleGrp")
        }
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);
        this.setState({
            selectedCrm: { name: '', id: '' },
            selectedEmployee: { first_name: 'Select Employee', last_name: '', id: '' },
            selectedRoleGrp: { name: '', id: '' },
            showRole: false, showRoleIndex: null, splittedRoleEmployees: []
        }, () => {
            this.filterCRM()
        })
    }

    crmGetReport() {
        let searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has("selectedOwnerDelivery")) {
            searchParams.delete("selectedOwnerDelivery")
        }
        if (searchParams.has("selectedSubSector")) {
            searchParams.delete("selectedSubSector")
        }
        if (searchParams.has("role")) {
            searchParams.delete("role")
        }
        if (searchParams.has("selectedOwnerRegion")) {
            searchParams.delete("selectedOwnerRegion")
        }
        if (searchParams.has("roleGroup")) {
            searchParams.delete("roleGroup")
        }
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);
        if (this.state.selectedCrm?.id || this.state.selectedEmployee?.id || this.state.selectedRoleGrp?.id) {
            this.setState({
                splittedRoleEmployees: [],
                selectedSubSector: [],
                selectedRole: [],
                selectedOwnerDelivery: [],
                selectedOwnerRegion: [],
                selectedRoleGroup: [],
            }, () => {
                this.getProjectsEmployees()
            })
        } else {
            this.props.enqueueSnackbar('Please select atleast one of the filters!', { variant: 'warning' })
        }
    }

    handleChange = (event) => {
        this.setState({ type: event.target.value }, () => {
        });
    }

    decreaseZoom = () => {
        let zoom = (Number(this.state.zoom) - 0.1).toFixed(1);
        if (zoom < 0.5) return;
        this.setState({ zoom: zoom })
    }

    increaseZoom = () => {
        let zoom = (Number(this.state.zoom) + 0.1).toFixed(1);
        if (zoom > 1.5) return;
        this.setState({ zoom: zoom })
    }

    screenSizeCheck() {
        if (window.innerWidth > 1600) {
            return true
        } else {
            return false
        }
    }

    changeView = (view) => {
        let searchParams = new URLSearchParams(window.location.search)
        searchParams.delete("selectedOwnerDelivery")
        searchParams.delete("selectedSubSector")
        searchParams.delete("role")
        searchParams.delete("selectedOwnerRegion")
        searchParams.delete("roleGroup")
        searchParams.delete("crm")
        searchParams.delete("employee")
        searchParams.delete("roleGrp")
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);
        this.setState({
            toggleView: view,
            selectedCrm: { name: '', id: '' },
            selectedEmployee: { first_name: 'Select Employee', last_name: '', id: '' },
            selectedRole: [],
            selectedOwnerRegion: [],
            selectedSubSector: [],
            selectedOwnerDelivery: [],
            selectedRoleGroup: [],
            showRole: false,
            showRoleIndex: null,
            splittedRoleEmployees: [],
            responseData: [],
            selectedRoleGrp: { name: '', id: '' },
        })
    }

    changeViewParent(view) {
        if (this.props.changeViewParent) {
            this.props.changeViewParent(view)
        }
    }

    filterRoleGroups(newValue) {
        this.setState({ selectedRoleGroups: newValue });
        console.log(this.state.splittedRoleEmployees)
    }

    getEmployeesBySelectedRoleGroups = (allEmployees) => {
        const selectedGroups = this.state.selectedFilterRoleGroup
        if (!selectedGroups || selectedGroups.length === 0) {
            return allEmployees
        }

        const selectedKey = this.getRoleGroupSelectionKey(selectedGroups)
        if (this.lastRoleGroupFilter && this.lastRoleGroupFilter.source === allEmployees && this.lastRoleGroupFilter.key === selectedKey) {
            return this.lastRoleGroupFilter.result
        }

        const roleIds = new Set()
        for (let i = 0; i < selectedGroups.length; i++) {
            const groupRoleIds = selectedGroups[i].role_ids || []
            for (let j = 0; j < groupRoleIds.length; j++) {
                roleIds.add(groupRoleIds[j])
            }
        }

        const filteredEmployees = allEmployees.filter((emp) => roleIds.has(emp.project_role_id))
        this.lastRoleGroupFilter = {
            source: allEmployees,
            key: selectedKey,
            result: filteredEmployees,
        }

        return filteredEmployees
    }

    handleFilterRoleGroup(selectedFilterRoleGroup) {
        this.setState({
            isLoading1: true
        })
        if (this.state.splittedRoleEmployees.length > 0) {
            const allEmp = this.getEmployeesBySelectedRoleGroups(this.state.splittedRoleEmployees[0].allEmpCopy, selectedFilterRoleGroup)
            this.setState({
                selectedFilterRoleGroup,
                splittedRoleEmployees: [{ ...this.state.splittedRoleEmployees[0], allEmp }],
            })
        }
        setTimeout(() => {
            this.setState({ isLoading1: false })
        }, 10);
    }

    handleChange = (event) => {
        this.setState({ type: event.target.value }, () => {
            this.getProjectsEmployees()
        });
    }

    render() {

        const handleClose = () => {
            this.setState({ allocationDialog: false, allocationDialogSize: "xs", allocationData: null }, () => {
                if (this.state.selectedCrm?.id) {
                    let allocationData = { prj: { crm: this.state.selectedCrm.id, crm_name: this.state.selectedCrm.name } }
                    this.setState({ allocationData })
                }
            })
        };

        return (
            <div>
                {this.state.isLoading ? <RotateCircleLoading color={getPrimaryColor()} /> :
                    <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} mt={7}>
                        <Box display='flex' justifyContent={'flex-end'} width={'100%'} alignItems={'center'}>
                            <RoleGroupFilterControl
                                options={this.state.roleGroups}
                                initialSelected={this.state.selectedFilterRoleGroup}
                                resetKey={`${this.state.toggleView}-${this.getRoleGroupSelectionKey(this.state.selectedFilterRoleGroup)}`}
                                disabled={this.state.isLoading1}
                                onApply={(selectedItems) => this.handleFilterRoleGroup(selectedItems)}
                            />
                            <ToggleButtonGroup
                                exclusive
                                aria-label="text alignment"
                                style={{ marginLeft: "10px", float: 'right' }}
                                size='small'
                                color='primary'
                            >
                                <ToggleButton value="weeks" aria-label="by week" onClick={this.decreaseZoom} >
                                    <ZoomOut />
                                </ToggleButton>
                                <ToggleButton value="months" aria-label="by month" onClick={this.increaseZoom}>
                                    <ZoomIn />
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                        <Box width='100%' display='flex' justifyContent='flex-end' alignItems='center' marginTop={1}>
                            <IconButton variant="contained" color="primary" size='small' style={{ marginRight: '10px' }} onClick={() => this.setState({ reportTypeDialog: true })}>
                                <GetAppIcon />
                            </IconButton>
                            <TextField
                                size='small'
                                select
                                variant='outlined'
                                value={this.state.type}
                                onChange={(e) => this.handleChange(e)}
                                SelectProps={{
                                    native: true,
                                }}
                                style={{ marginRight: '0px' }} >
                                {['week', 'month', 'quarter'].map((option) => (
                                    <option key={option} value={option}>
                                        {option[0].toUpperCase() + option.slice(1)}
                                    </option>
                                ))}
                            </TextField>
                        </Box>
                        <Box marginTop={1}>
                            {
                                this.state.isLoading1 ? <LoopCircleLoading color={getPrimaryColor()} /> :
                                    <div>{this.state.splittedRoleEmployees.length > 0 ?
                                        <div>
                                            {this.state.splittedRoleEmployees.map((role, roleIndex) => (
                                                <div style={{ zoom: this.state.zoom }}>
                                                    <StaffLocationViewHeader
                                                        disciplineObj={this.state.disciplineObj}
                                                        crm={this.props.crm}
                                                        selectedStartDate={this.state.selectedStartDate}
                                                        selectedEndDate={this.state.selectedEndDate}
                                                        rolesObj={this.state.rolesObj}
                                                        refreshData={this.handleRefresh}
                                                        roleData={this.state.splittedRoleEmployees[roleIndex]}
                                                        projectObj={this.state.projectObj}
                                                        role={this.state.reportedRoles[roleIndex]}
                                                        templateRoles={this.state.responseData}
                                                        allOtherTasks={this.state.allOtherTasks}
                                                        allEmployeesLeaves={this.state.allEmployeesLeaves}
                                                        othertaskObject={this.state.othertaskObject}
                                                        allProjects={this.state.allProjects}
                                                        allRoles={this.state.allRoles}
                                                        liveOpportunities={this.state.liveOpportunities}
                                                        updateTheUpdatedSchedules={this.editedScheduleUIUpdate}
                                                        addAllocation={this.addAllocation}
                                                        type={this.state.type}
                                                        roles={this.state.roles}
                                                    />
                                                </div>))
                                            }
                                        </div>
                                        : <Typography style={{ textAlign: 'center' }}>No report available for the selected Options</Typography>}
                                    </div>
                            }
                        </Box>

                        <Dialog
                            fullWidth
                            maxWidth={this.state.allocationDialogSize}
                            open={this.state.allocationDialog}
                            TransitionComponent={Transition}
                            disableEnforceFocus>
                            <DialogTitle>
                                <Box display={'flex'} flexDirection={'row'} width={'100%'} alignItems={'center'}>
                                    <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
                                        {!this.state.allocationData ? "Add Employee" : this.state.allocationData?.emp ? ("Add Resource to " + this.state.allocationData?.emp?.first_name + " " + this.state.allocationData?.emp?.last_name) : this.state.allocationData?.prj?.crm_name ? ("Add Resource to " + this.state.allocationData?.prj?.crm_name) : "Add Resource"}
                                    </Typography>
                                    <IconButton onClick={handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </DialogTitle>
                            <DialogContent>
                                <UserAllocation
                                    type={'staff_location'}
                                    getDialogSize={this.getDialogSize}
                                    closeDialog={this.closeDialog}
                                    allocationData={this.state.allocationData}
                                    filters={
                                        {
                                            selectedRole: this.state.selectedRole,
                                            selectedSubSector: this.state.selectedSubSector,
                                            selectedOwnerRegion: this.state.selectedOwnerRegion,
                                            selectedOwnerDelivery: this.state.selectedOwnerDelivery,
                                            selectedRoleGroup: this.state.selectedRoleGroup,
                                            selectedCrm: this.state.selectedCrm,
                                            selectedEmployee: this.state.selectedEmployee,
                                            selectedRoleGrp: this.state.selectedRoleGrp
                                        }
                                    }
                                />
                            </DialogContent>
                        </Dialog>

                        <Dialog open={this.state.excelExportDialog} onClose={() => this.setState({ excelExportDialog: false })} >
                            <DialogContentText>
                                <Box margin={2}>
                                    The Report will be emailed to {user.email}
                                </Box>
                            </DialogContentText>
                            <DialogActions>
                                <Button onClick={() => this.setState({ excelExportDialog: false, reportTypeDialog: false })} color="primary">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog open={this.state.reportTypeDialog} onClose={() => this.setState({ reportTypeDialog: false })} maxWidth='xs' fullWidth>
                            <DialogTitle>
                                <Box>
                                    <Typography>Select Report Type</Typography>
                                    <IconButton onClick={() => this.setState({ reportTypeDialog: false })} style={{ position: 'absolute', right: 8, top: 8, color: 'red' }}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </DialogTitle>
                            <DialogContentText>
                                <Box marginLeft={3}>
                                    Select the report type you want to generate.
                                </Box>
                            </DialogContentText>
                            <DialogActions>
                                <Button color='primary' size='small' disabled={this.state.exporting} onClick={() => { this.exportExcel('week') }}>Week</Button>
                                <Button color='primary' size='small' disabled={this.state.exporting} onClick={() => { this.exportExcel('month') }}>Month</Button>
                                <Button color='primary' size='small' disabled={this.state.exporting} onClick={() => { this.exportExcel('quarter') }}>Quarter</Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog maxWidth="sm" open={this.state.coffeeLoading} aria-labelledby="form-dialog-title">
                            <DialogContent>
                                <Box m={5} p={2}>
                                    <CoffeeLoading />
                                </Box>
                            </DialogContent>
                        </Dialog>
                    </Box>
                }
            </div >)
    }
}

export default withSnackbar(ProjectStaffLocationView)